module.exports = "/images/icon_fb_white.png?9205f23f2c7d6ab57705037a8f844d15";